import { Turbo } from "@hotwired/turbo-rails"
import TurboPower from "turbo_power"

TurboPower.initialize(Turbo.StreamActions)

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "../controllers"

import "../application.scss"

import "@rails/actiontext"
import "trix"
import "trix/dist/trix.css"
import "../actiontext.css"

import "shepherd.js/dist/css/shepherd.css"

// disable attachments for trix fields
document.addEventListener("trix-file-accept", (e)=>{
  e.preventDefault();
});